export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const SET_ADDITIONAL_USER_INFO = 'SET_ADDITIONAL_USER_INFO';
export const CLEAR_JOIN = 'CLEAR_JOIN';
export const SET_PRIMARY = 'SET_PRIMARY';
export const SET_SECONDARY = 'SET_SECONDARY';
export const TRANSFER_PERSON = 'TRANSFER_PERSON';
